module.exports = __webpack_public_path__ + "img/hr.a7904cc9.svg";